module.exports = __webpack_public_path__ + "app/assets/images/woman3-266573bb7956424a5ac311cc0a989d4d.jpg";